import React from "react";
import VLActionModal from "views/uikit/VLModal/VLActionModal";
import SelectList from "views/uikit/FormFields/SelectList";

interface SelectClassesModalProps {
  isModalOpen: boolean;
  onCLose: () => void;
  options: { label: string; value: string }[];
  selectedValues: string[];
  setSelectedValues: React.Dispatch<React.SetStateAction<string[]>>;
  loading?: boolean;
  onAdd: () => void;
}

export default function SelectClassesModal({
  isModalOpen,
  onCLose,
  options,
  selectedValues,
  setSelectedValues,
  loading,
  onAdd,
}: SelectClassesModalProps) {
  return (
    <VLActionModal
      isOpen={isModalOpen}
      onClose={onCLose}
      onClick={onAdd}
      actionLabel={"Add"}
      headers={{
        title: "Add Classes",
        subTitle: "Select K Classes From Your Taxonomy",
      }}
      variant={"general"}
      direction="row"
    >
      <SelectList
        options={options}
        placeholder="Select classes"
        value={selectedValues}
        onChange={setSelectedValues}
        loading={loading}
        mode={"multiple"}
      />
    </VLActionModal>
  );
}
